import React from 'react';
import { FadeIn, Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ["Dices 'mañana lo reviso' y pasan semanas enteras.", 'Pagas mínimos... y sientes que la deuda nunca baja.', "Te prometes que ahora sí vas a 'organizarte'... y te dura 3 días.", 'Te sientes culpable por compras pequeñas, pero necesitas alivio.'];
  return <Section background="cream-dark" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <FadeIn data-id="element-77">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-4 text-[#4A3728]" data-id="element-78">
            Esto probablemente te pasa <br className="hidden md:block" data-id="element-79" />
            <span className="italic text-[#8C7B70] text-2xl md:text-3xl font-normal" data-id="element-80">
              (y no se lo dices a nadie)
            </span>
          </h2>
        </FadeIn>

        <div className="mt-12 space-y-6" data-id="element-81">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} className="flex items-start bg-[#FAF7F2] p-6 rounded-xl shadow-sm" data-id="element-82">
              <XCircle className="w-6 h-6 text-[#C4956A] mt-1 mr-4 flex-shrink-0" data-id="element-83" />
              <p className="text-lg text-[#5C4D44]" data-id="element-84">{point}</p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} className="mt-12 text-center space-y-6" data-id="element-85">
          <p className="text-xl font-medium text-[#4A3728]" data-id="element-86">
            Y lo peor: no es que no quieras hacerlo bien.
          </p>
          <p className="text-lg text-[#6B5D52] max-w-2xl mx-auto" data-id="element-87">
            Es que no tienes espacio mental para un sistema grande. Cuando estás
            en supervivencia, "organizarte" suena como otro trabajo más.
          </p>
        </FadeIn>
      </div>
    </Section>;
}